'use client';

import { useEffect, useState } from 'react';
import { sanitizeBanner, sanitizeHTML, sanitizeHTMLStrict } from './sanitizeHTML';

export const useSanitizedHTML = (dirty, options = {}) => {
    const [clean, setClean] = useState(() => sanitizeHTML(dirty, options));

    useEffect(() => {
        if (!dirty || typeof dirty !== 'string') {
            setClean('');
            return;
        }

        import('isomorphic-dompurify').then((DOMPurify) => {
            window.DOMPurify = DOMPurify.default;
            setClean(sanitizeHTML(dirty, options));
        }).catch(() => {
            setClean(sanitizeHTML(dirty, options));
        });
    }, [dirty, options]);

    return clean;
};

export const useSanitizedHTMLStrict = (dirty) => {
    const [clean, setClean] = useState(() => sanitizeHTMLStrict(dirty));

    useEffect(() => {
        if (!dirty || typeof dirty !== 'string') {
            setClean('');
            return;
        }

        import('isomorphic-dompurify').then((DOMPurify) => {
            window.DOMPurify = DOMPurify.default;
            setClean(sanitizeHTMLStrict(dirty));
        }).catch(() => {
            setClean(sanitizeHTMLStrict(dirty));
        });
    }, [dirty]);

    return clean;
};

export const useSanitizedBanner = (dirty, allowedDomains = []) => {
    const [clean, setClean] = useState(() => sanitizeBanner(dirty, allowedDomains));

    useEffect(() => {
        if (!dirty || typeof dirty !== 'string') {
            setClean('');
            return;
        }

        import('isomorphic-dompurify').then((DOMPurify) => {
            window.DOMPurify = DOMPurify.default;
            setClean(sanitizeBanner(dirty, allowedDomains));
        }).catch(() => {
            setClean(sanitizeBanner(dirty, allowedDomains));
        });
    }, [dirty, allowedDomains]);

    return clean;
};